import { createFileRoute } from '@tanstack/react-router';
import { JourneysCdpHandoff } from '@/pages/workspaces/journeys/integrations/cdp/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/integrations/cdp_in` URL — what the integrations directory links to.
 * Flag off it renders the embedded Ember host; flag on it forwards to the migrated URL.
 */
function JourneysCdpInRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysCdpHandoff connector="cdp_in" />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/integrations/cdp_in')({
  component: JourneysCdpInRoute,
});
